import React, { useEffect, useState } from "react";
import backgroundImage from "../../../../assets/images/billing-header.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import BillingComponent from "../../Dashboard/billing/BillingHistory";
import { ReactComponent as PurchaseCompany } from "../../../../assets/icons/PurchaseCompany.svg";
import { Button, Modal } from "../../../common";
import { Aed } from "../../../common/Money";
import { useGetUserSubscriptionListQuery, useGetVerifyCompanyPaymentFetchQuery } from "../../../../store/Company/companyApiSlice";
import { useCancelSubscriptionMutation, useCreateVerifiedCustomerPortalSessionMutation } from "../../../../store/Billing/billingApiSlice";
import { CancelSubscriptionConfirmation } from "../../../common/CancelSubscriptionConfirmatiion";
import { CancelationSuccess } from "../../../common/CancelationSuccess";
import { selectActiveCompany } from "../../../../store/activeCompanySlice";
// TIP-554 — active-plan picker prefers 'verified' over 'freemium' when both
// rows are active (existing members have both; freemium used to win).
import { pickActiveSub } from "../../../../utils/pickActiveSubscription";

export const Subscription = () => {
  const [subscriptionCompanies, setSubscriptionCompanies] = useState([]);
  const [billingData, setbillingData] = useState([]);
  const [activeSub, setActiveSub] = useState("");
  const [hidePlan, sethidePlan] = useState(false)
  const [getConfirm, setGetConfirm] = useState(false);
  const [cancelSuccess, setCancelSuccess] = useState(false);
  const { userInfo, token } = useSelector((state) => state.auth);
  const activeCompany = useSelector(selectActiveCompany);
  // const [subscriptionData, setSubscriptionData] = useState([]);
  const todaysDate = new Date();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo) {
      let subscriptionArr = userInfo.individual[0]?.individual_data?.filter(
        (company) => !company.ind_compID
      );
      setSubscriptionCompanies(subscriptionArr);
    }
  }, [userInfo]);

  const subscriptionIDs = [];
  if (subscriptionCompanies?.length > 0) {

    if (subscriptionCompanies[0]?.length > 1) {
      subscriptionCompanies?.map((individual) => {
        subscriptionIDs.push(individual?.subscriptionID?.subscriptionID);
      });
    } else {
      subscriptionIDs[0] =
        subscriptionCompanies[0]?.subscriptionID?.subscriptionID;
    }
  }
  const containerStyles = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    imageRendering: 'auto'
    // backgroundColor:"#002940"
  };
  let data = [];

  // TODO: there is no need to individualID in API
  const { data: subscriptionData, refetch: refetchSubscription } = useGetUserSubscriptionListQuery({
    individualID: userInfo?.individual[0]?.individualID,
    token: token
  },
    {
      refetchOnMountOrArgChange: true,
    });

  // useEffect(()=>{
  //   setSubscriptionData(subscriptions?.filter(subscription => subscription.subscription_type !== "freemium"))
  // },[subscriptions])

  // TODO: there is no need to individualID in API
  const { data: verifyCompanyData, refetch: refetchVerifiedData } = useGetVerifyCompanyPaymentFetchQuery({
    individualID: userInfo?.individual[0]?.individualID,
    token: token
  });

  useEffect(() => {
    refetchSubscription();
    refetchVerifiedData();
  }, [userInfo])

  useEffect(() => {
    let tempcompanyData;
    let tempcompanyData1;
    if (subscriptionData && verifyCompanyData?.length > 0) {
      tempcompanyData1 = verifyCompanyData.concat(subscriptionData);
    }
    else if (verifyCompanyData?.length > 0) {
      tempcompanyData1 = verifyCompanyData;
    }
    else if (subscriptionData) {
      const getActiveSub = pickActiveSub(subscriptionData, todaysDate);
      const getInvalidUrl = subscriptionData?.find((i) => (i?.invoice_url === "null" && i?.subscription_type !== "freemium"));
      if (getInvalidUrl) {
        sethidePlan(true)
      } else {
        sethidePlan(false)
      }
      setActiveSub(getActiveSub);
      tempcompanyData1 = subscriptionData;
    }
    if (tempcompanyData1 != undefined) {
      tempcompanyData = tempcompanyData1.slice().sort((a, b) => {
        return new Date(b?.date_of_start) - new Date(a?.date_of_start)
      });
      // const tempDataSet = tempcompanyData?.filter((company) => company?.subscription_type !== "freemium")
      setbillingData(tempcompanyData)
    }
  }, [subscriptionData, verifyCompanyData, activeSub]);
  const plan = [
    {
      subscription_type: "pay-as-you-go",
      profile: 1,
      amount: 79,
    },
    {
      subscription_type: "basic",
      profile: 3,
      amount: 195,
    },
    {
      subscription_type: "pro",
      profile: 5,
      amount: 275,
    },
    {
      subscription_type: "premium",
      profile: 10,
      amount: 500,
    },
    // TIP-464 — Verified Company subscription. Monthly + annual both
    // share subscription_type='verified'; the actual amount (99 vs 999)
    // lives on the Subscription row itself, so this entry is just a
    // fallback for display when the row isn't loaded yet.
    {
      subscription_type: "verified",
      profile: 0,
      amount: 99,
    },

  ];
  const getSubAmount = (subscription_type) => {
    const res = plan?.find((i) => i?.subscription_type === subscription_type);
    return res?.amount;
  };

  // TIP-464 — verified subscriptions display in AED and may be monthly
  // or yearly. Discriminate by the row's amount field (99 = monthly,
  // 999 = yearly). Falls back gracefully if amount is missing.
  const isVerifiedSub = activeSub?.subscription_type === "verified";
  // Apple-style three-state model:
  //   * Renewing       — status=active, recurring_status=active   → "Next renewal on X"
  //   * Cancel pending — status=active, recurring_status=cancelled → "Expires on X" (badge stays)
  //   * Expired        — status=inactive                            → "Expired — renew today"
  const isVerifiedScheduledCancel = isVerifiedSub
    && activeSub?.status === "active"
    && activeSub?.recurring_status === "cancelled";
  const isVerifiedExpired = isVerifiedSub && activeSub?.status === "inactive";
  const verifiedIsAnnual = isVerifiedSub && Number(activeSub?.amount) >= 500;
  const priceCurrency = isVerifiedSub ? "AED" : "$";
  const priceAmount = isVerifiedSub
    ? Number(activeSub?.amount) || 0
    : getSubAmount(activeSub?.subscription_type) || 0;
  const pricePeriod = verifiedIsAnnual ? "per year" : "per month";

  // TIP-464 — "8th January 2029" style. Used to render the verified
  // sub's next renewal date.
  const formatRenewalDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) return dateString;
    const day = d.getDate();
    const j = day % 10;
    const k = day % 100;
    const suffix =
      j === 1 && k !== 11 ? "st" :
        j === 2 && k !== 12 ? "nd" :
          j === 3 && k !== 13 ? "rd" : "th";
    const months = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    return `${day}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
  };

  const handleNavigate = () => {
    window.scrollTo(0, 0);
    // TIP-494: "Buy a plan" in billing buys MEMBERSHIP, not the legacy
    // web-profile flow (/plans = "Buy a Company Profile"). Route to the
    // membership checkout for the active company; fall back to the dashboard
    // membership page if no company is selected.
    const companyID = activeCompany?.companyID;
    if (companyID) {
      navigate(`/membership/${companyID}`);
    } else {
      navigate("/dashboard/membership");
    }
  };

  const onDownloadInvoiceAll = () => {
    const getAllPdf = data?.map((i) => i?.trevex_invoice ? i?.trevex_invoice : i?.invoice_url);
    const downloadPdf = (url) => {
      const a = document.createElement("a");
      a.href = url;
      a.target = '_blank';
      a.download = "invoice.pdf";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    getAllPdf.forEach((url) => {
      downloadPdf(url);
    });
  };

  const onDownloadInvoice = async (url) => {
    try {
      const parsedUrl = new URL(url, window.location.origin);

      // Allow only the same protocol as the current application
      const allowedProtocols =
        window.location.protocol === "https:"
          ? ["https:"]
          : ["http:", "https:"];

      if (!allowedProtocols.includes(parsedUrl.protocol)) {
        throw new Error("Invalid URL protocol.");
      }

      const response = await fetch(parsedUrl.toString(), {
        method: "GET",
        credentials: "include",
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();

      const objectUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "invoice.pdf";
      link.rel = "noopener noreferrer";

      link.click();

      // Revoke after the browser starts the download
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 100);

    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  // const onDownloadInvoice = (url) => {
  //   window.open(url, '_blank');
  // };

  const [cancelSubscription] = useCancelSubscriptionMutation();
  const [createPortalSession, { isLoading: portalLoading }] = useCreateVerifiedCustomerPortalSessionMutation();
  const [cancelled, setCancelled] = useState("");

  // TIP-464 — opens Stripe Customer Portal in a new tab. Used only for
  // Verified subscriptions (legacy /plans flow has no portal yet).
  const handleManageSubscription = async () => {
    const res = await createPortalSession(token);
    if (res?.data?.portal_url) {
      window.open(res.data.portal_url, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    const res = pickActiveSub(subscriptionData, todaysDate);
    // TIP-464 — when no truly-active sub but the user previously had a
    // Verified subscription that's now cancelled, surface that row so
    // the dashboard shows "Cancelled — access ended on X" instead of
    // jumping straight to the "Buy a plan" empty state.
    const cancelledVerified = !res
      ? subscriptionData?.find((i) =>
        i?.subscription_type === "verified" &&
        (i?.recurring_status === "cancelled" || i?.status === "inactive")
      )
      : null;
    const surfaced = res || cancelledVerified;
    setActiveSub(surfaced);
    setCancelled(surfaced?.recurring_status);
  }, [subscriptionData, userInfo]);

  const handleCancelSubscription = async () => {
    const res = await cancelSubscription(activeSub?.stripe_subscription_id);
    if (res) {
      setGetConfirm(false);
      setCancelSuccess(true);
      setCancelled(res?.data?.message);
    }
  };
  return (
    <>
      {(billingData?.length > 0 || subscriptionData?.length > 0) ? (
        <>
          <div className="p-4 sm:p-6 rounded-lg my-4" style={containerStyles}>
            {activeSub?.subscription_type ?
              <div className="flex flex-col sm:flex-row justify-between py-4 items-center">
                <div className="text-start ">
                  <h3 className="text-slate text-f18 pb-2 capitalize">
                    {isVerifiedSub
                      ? `Membership — ${verifiedIsAnnual ? "Annual" : "Monthly"}${isVerifiedExpired ? " (Expired)" : (isVerifiedScheduledCancel ? " (Cancel pending)" : "")}`
                      : (activeSub?.subscription_type || "No Subscription")}
                  </h3>
                  {activeSub?.subscription_type === "pay-as-you-go" ? null : (
                    <p className="text-slate text-f14 font-extralight" style={(isVerifiedScheduledCancel || isVerifiedExpired) ? { color: "#FFD4C5" } : undefined}>
                      {isVerifiedSub
                        ? (isVerifiedExpired
                          ? `Expired on ${formatRenewalDate(activeSub?.date_of_end)}`
                          : isVerifiedScheduledCancel
                            ? `Cancellation scheduled — keeps benefits until ${formatRenewalDate(activeSub?.date_of_end)}`
                            : (verifiedIsAnnual ? "Billed annually — auto-renews" : "Billed monthly — auto-renews"))
                        : "pay on a monthly subscription"}
                    </p>
                  )}
                  {/* TIP-464 — card reference for Verified subscriptions */}
                  {isVerifiedSub && activeSub?.card_last4 && (
                    <p className="text-slate text-f13 font-extralight" style={{ marginTop: 6, opacity: 0.85 }}>
                      Card · {(activeSub?.card_brand || "").replace(/^./, c => c.toUpperCase())} •••• {activeSub.card_last4}
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-2 text-start">
                  <span className="text-slate text-f36 font-bold">
                    {isVerifiedSub ? <Aed value={priceAmount} /> : <>{priceCurrency} {priceAmount}</>}
                  </span>
                  <p className="text-slate text-f14 font-extralight">
                    {pricePeriod}
                  </p>
                </div>
              </div> :
              <><div className="flex flex-col sm:flex-row justify-between py-4 items-center">
                <div className="text-start ">
                  <h3 className="text-slate text-f18 pb-2 capitalize">
                    {"No Active Subscription"}
                  </h3>
                </div>
                <div className="flex items-center gap-2 text-start">
                  <div className="">
                    <button
                      className="text-slate border flex justify-between gap-5 items-center border-white text-f18 font-semibold p-4 rounded-lg"
                      onClick={handleNavigate}
                    >
                      Buy a plan
                      <span>
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.5 13L13.5 1M13.5 1H4.5M13.5 1V10"
                            stroke="#EBF0F3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              </>}
            {activeSub?.subscription_type && <hr />}
            {activeSub?.subscription_type && <div className="flex justify-between py-4 items-center flex-col sm:flex-row gap-3">
              <div className="text-start flex flex-col gap-2">
                {/* TIP-464 — Verified subs don't track per-profile credits
                    (it's a per-company badge), so hide that legacy line. */}
                {!isVerifiedSub && (
                  <span className="text-slate text-f14  font-extralight">
                    No. of profile credits remaining :{" "}
                    <b className="text-f16">
                      {" "}
                      {activeSub?.no_of_profile_views || 0}
                    </b>
                  </span>
                )}
                <span className="text-slate text-f14 font-extralight">
                  {isVerifiedSub
                    ? (isVerifiedExpired
                      ? <>Verification badge revoked. <a href="#renew" onClick={(e) => { e.preventDefault(); handleManageSubscription(); }} className="underline" style={{ color: "#FB512D", marginLeft: 4 }}>Click here to renew today</a>.</>
                      : isVerifiedScheduledCancel
                        ? <>Expires on: <b className="text-f16">{formatRenewalDate(activeSub?.date_of_end)}</b></>
                        : <>Next renewal on: <b className="text-f16">{formatRenewalDate(activeSub?.date_of_end)}</b></>)
                    : <>Last Claim : {activeSub?.date_of_end || "No Subscription"}</>}
                </span>
              </div>
              {!hidePlan && <div className="">
                {/* TIP-464 — verified subs go to Stripe Customer Portal for
                    card / plan / cancel; legacy subs navigate to /plans. */}
                <button
                  className="text-slate border flex justify-between gap-5 items-center border-white text-f18 font-semibold p-4 rounded-lg"
                  onClick={isVerifiedSub ? handleManageSubscription : handleNavigate}
                  disabled={isVerifiedSub && portalLoading}
                >
                  {isVerifiedSub
                    ? (portalLoading
                      ? "Redirecting…"
                      : isVerifiedExpired
                        ? "Renew today"
                        : "Manage subscription")
                    : "Modify plan"}
                  <span>
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.5 13L13.5 1M13.5 1H4.5M13.5 1V10"
                        stroke="#EBF0F3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </div>}
            </div>}
          </div>

          {!hidePlan && <BillingComponent
            data={billingData.length > 0 ? billingData : subscriptionData}
            activeSub={activeSub}
            cancelled={cancelled}
            setGetConfirm={setGetConfirm}
            getSubAmount={getSubAmount}
            onDownloadInvoiceAll={onDownloadInvoiceAll}
            id={activeSub?.subscriptionID}
            onDownloadInvoice={(data) => onDownloadInvoice(data)}
          />}
        </>
      ) : (
        <div className="flex flex-col items-center gap-5 justify-center w-1/3 mx-auto p-5 pkpp">
          <PurchaseCompany />
          <span className="text-secondary text-f14 w-2/3">
            All your Bilings will appear here
          </span>
          <Button
            onClick={handleNavigate}
            classes="border-link text-f14 text-link font-semibold border py-2 px-5 rounded"
          >
            Start Purchasing
          </Button>
        </div>
      )}
      {getConfirm && (
        <Modal modalHandle={() => setGetConfirm(false)}>
          <CancelSubscriptionConfirmation
            onclick={() => setGetConfirm(false)}
            handleCancelSubscription={handleCancelSubscription}
            title={" Are you sure?"}
            des2={`Your current subscription will end on <b>${new Date(
              activeSub?.date_of_end
            ).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}</b>`}
            des={`Please confirm your decision to cancel your subscription. Remember, upon cancellation, you'll lose claim to all premium features.`}
            leftButton={"Keep Subscription"}
            rightButton={"Confirm Cancellation"}
          />
        </Modal>
      )}

      {cancelSuccess && (
        <Modal modalHandle={() => setCancelSuccess(false)}>
          <CancelationSuccess
            title={"Subscription Cancelled?"}
            des2={`Your current subscription will end on <b>${new Date(
              activeSub?.date_of_end
            ).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}</b>`}
            des={`We're sad to see you go. Your subscription has been cancelled. You'll have claim to premium features until the end of your billing cycle.`}
          />
        </Modal>
      )}
    </>
  );
};
